import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './style.m.less';

const ApiWarning = ({ children }) => (
    <section className={styles.container}>
        <img src="/images/si-bot-warning.svg" className={classNames(styles.image, styles.tilted)} alt="" />
        {children}
    </section>
);

ApiWarning.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ApiWarning;
